import { createAction, props } from '@ngrx/store';
import { Assessment, UserAssessment } from './assessment.models';

export const loadAssessments = createAction(
  '[Assessment] Load Assessments',
  props<{ categoryId: string }>()
);

export const loadAssessmentsSuccess = createAction(
  '[Assessment] Load Assessments Success',
  props<{ assessments: Assessment[] }>()
);

export const loadAssessmentsFailure = createAction(
  '[Assessment] Load Assessments Failure',
  props<{ error: any }>()
);

export const loadUserAssessments = createAction(
  '[Assessment] Load User assessments',
  props<{userId: string}>()
);

export const loadUserAssessmentsSuccess = createAction(
  '[Assessment] Load User assessments Success',
  props<{assessments: UserAssessment[]}>()
);

export const loadUserAssessmentsFailure = createAction(
  '[Assessment] Load User assessments Failure',
  props<{error: string}>()
);


export const createUserAssessment = createAction(
  '[Assessment] Create User assessment',
  props<{userId: string, categoryId: string, assessmentId: string}>()
);

export const createUserAssessmentSuccess = createAction(
  '[Assessment] Create User assessment Success',
  props<{assessment: UserAssessment}>()
);

export const createUserAssessmentFailure = createAction(
  '[Assessment] Create User assessment Failure',
  props<{error: string}>()
);

export const submitUserAssessmentQuestion = createAction(
  '[Assessment] Submit User assessment Question',
  props<{userId: string, question: string, answer: any, assessmentId: string, action?: 'SUBMIT'}>()
);

export const submitUserAssessmentQuestionSuccess = createAction(
  '[Assessment] Submit User assessment Question Success',
  props<{assessment: UserAssessment}>()
);

export const submitUserAssessmentQuestionFailure = createAction(
  '[Assessment] Submit User assessment Question Failure',
  props<{error: string}>()
);

export const loadUserAssessment = createAction(
  '[Assessment] Load User assessment',
  props<{userId: string, assessmentId: string}>()
);

export const loadUserAssessmentSuccess = createAction(
  '[Assessment] Load User assessment Success',
  props<{assessment: UserAssessment}>()
);

export const loadUserAssessmentFailure = createAction(
  '[Assessment] Load User assessment Failure',
  props<{error: string}>()
);

export const clearCurrentUserAssessment = createAction(
  '[Assessment] Clear Current User Assessment'
);

export const clearAssessment = createAction(
  '[Assessment] Clear Assessment'
);
